import { useMemo } from "react";
import { bool, object } from "prop-types";
import { observer } from "mobx-react";
import {
  PinnableCell,
  DescriptionTitleEditor,
  useEstimateEditorSettings,
  useEstimateEditorStore,
  usePresetFieldNames,
  useVisibilityModeCellClassName,
  VisibilityButton,
  useEstimateTableSettings,
} from "@tools";
import { Grid } from "@material-ui/core";
import { LastPinnedCellActions } from "../components/LastPinnedCellActions";
import { NewDescriptionButton } from "../components/NewDescriptionButton";
import classnames from "classnames";
import useCellStyle from "@tools/EstimateEditor/styles/CommonTableCellStyles.style";

export const TaskDescriptionCell = observer(({
  columnSettings,
  section,
  isLastPinnedCell,
  isLastPinnableCell,
}) => {
  const { allowEdition, isProposal, isLibrary } = useEstimateEditorSettings();
  const { showActionsOnScroll } = useEstimateTableSettings();
  const { visibilityMode } = useEstimateEditorStore();
  const className = useVisibilityModeCellClassName(columnSettings.hide);
  const { getFieldName } = usePresetFieldNames(isProposal);
  const cellClasses = useCellStyle();

  const { id, descriptionIndex, hide, pinLeftPx, displayName } = columnSettings;
  const field = `pt-desc${descriptionIndex ? descriptionIndex + 1 : ""}`;

  const { usedAllDescriptionColumns } = section;
  
  const showActions = useMemo(() => (
    showActionsOnScroll ? isLastPinnedCell : isLastPinnableCell
  ), [ isLastPinnedCell, isLastPinnableCell, showActionsOnScroll ]);

  return <>
    <PinnableCell
      resizeable
      isHeader
      widerPaddings
      colName={ id }
      
      allowOverflowDisplay={isLastPinnedCell}
      pinnedLeft={typeof pinLeftPx === "number"}
      
      actions={ showActions && <LastPinnedCellActions section={section} /> }
      allowEdition={ allowEdition && !isLibrary }
      columnSettings={ columnSettings }
      innerClassName="items-end"
    >
      <Grid
        item container
        alignItems="center"
        wrap="nowrap"
        className={classnames("text-left", cellClasses.sizeXSmall, className)}
      >
        {
          allowEdition
            ? <DescriptionTitleEditor
              section={section}
              columnSettings={columnSettings}
            />
            : <span className={`preset-tableBreakdownHeader ${field} ml-0-5 break-word`}>
              { getFieldName(field, undefined, undefined, displayName) }
            </span>
        }
        {
          allowEdition && showActions &&
          <NewDescriptionButton
            section={section}
            usedAllDescriptionColumns={usedAllDescriptionColumns}
          />
        }
        {
          visibilityMode &&
          <VisibilityButton
            size="tiny"
            hidden={hide}
            onChange={columnSettings.setHide}
          />
        }
      </Grid>
    </PinnableCell>
  </>
})

TaskDescriptionCell.propTypes = {
  section: object.isRequired,
  columnSettings: object.isRequired,
  isLastPinnedCell: bool,
  isLastPinnableCell: bool,
}
